<template>
  <modal name="curator-update-modal" class="curator-update-modal"
         :width="300"
         :height="'auto'"
         @before-open="handlerBeforeOpen"
         @before-close="handlerBeforeClose"
  >
    <div class="modal_title">큐레이터</div>
    <button class="close_btn" style="z-index: 99" @click="closeModal"></button>
    <div class="text_center mt30 mb50">
      <el-select class="select curator_select" v-model="curatorUpdate"
                 @change="changeType(curatorUpdate)">
        <el-option :value="1" :label="'일반'"></el-option>
        <el-option :value="2" :label="'큐레이터'"></el-option>
      </el-select>
    </div>
    <div class="pl30 pr30 pb30">
      <div class="btn_box text-center mt20">
        <el-button class="reg_btn_out" @click="save">학인</el-button>
      </div>
    </div>
  </modal>
</template>

<script>
import EventBus from "@/utils/event-bus";

export default {
  name: "CuratorUpdateModal",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      curatorUpdate: 1,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    handlerBeforeOpen(event) {
      console.log(event)
      if(event.params == 2){
        this.curatorUpdate = event.params;
      } else {
        this.curatorUpdate = 1;
      }
    },
    handlerBeforeClose() {
      this.$router.replace(this.$route.path);
    },
    closeModal() {
      this.$modal.hide('curator-update-modal')
    },
    changeType(value){
      this.curatorUpdate = value;
    },
    save(){
      EventBus.$emit('updateCuratorType', this.curatorUpdate, 'curatorType');
      this.$modal.hide('curator-update-modal')
    }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>